import { Client } from 'colyseus.js';
import { makeAutoObservable, runInAction } from 'mobx';
import { cacheService } from './services/cacheService';
import { IOnAuth, IUser } from './types/global.types';
import { globalStore } from './global.store';
import {
  IReceivedMsg,
  TSendMessage,
} from './modules/scenetemplate/hooks/constants';
import { chatStore } from './components/chat/chat.store';
import { envService } from './services/envService';
import { apiColyseusBase } from './services/apiService';
import { TMovement } from './Scenes/types';

class SocketStore {
  user: IUser | null;

  dashboardState: any | null;

  client: any = new Client(envService.getSocketApiUrl);

  dashboard: any;

  room: any;

  gameState: any = {};

  showMyAssetsPopup = false;

  constructor() {
    makeAutoObservable(this);
  }

  get socketUsers() {
    try {
      return Object.fromEntries(this.dashboard?.state?.users.entries()) || {};
    } catch (error) {
      console.warn(error);
      return {};
    }
  }

  get roomUsers() {
    try {
      return this.room?.state?.players || {};
    } catch (error) {
      console.warn(error);
      return {};
    }
  }

  logOut = () => {
    this.sendSocketMessage('logOut');
  };

  sendSocketMessage = (command: string, data: any = {}) => {
    try {
      this.dashboard.send(command, data);
    } catch (error) {
      console.log(error);
    }
  };

  leave = async () => {
    return await this.dashboard.leave();
  };

  joinDashboard = async () => {
    try {
      this.dashboard && (await this.leave());
      this.dashboard = await this.client.joinOrCreate("media-api", {token:cacheService.getAuthToken});

      this.dashboard.onMessage('onAuth', this.onAuth);
      this.dashboard.onMessage('dubleLogin', this.onDubleLogin);
      this.dashboard.onMessage('sendExistMsg', chatStore.setExistMsg);
      this?.dashboard?.onStateChange((data: any) => {
        const aaa = Object.fromEntries(data.users.entries());
        this.updateDashboardUsers(aaa);
      });
      this.dashboard.onMessage('privateMessage', this.onPrivateMessage);
      this.dashboard.onMessage('globalMessage', chatStore.setGlobalMsg);

      this.dashboard.onError((error: any) => {
        console.warn('connection closed');
      });

      this.dashboard.onLeave(async () => {
        console.warn('connection closed');
      });
      return this.dashboard;
    } catch (error) {
      console.log(error);
    }
  };

  get myId() {
    return this.user?.id || '0';
  }

  joinRoom = async (roomId: string) => {
    try {
      await this.joinDashboard();
      this.sendSocketMessage('onJoinRoom', {
        roomId,
        socketId: this.dashboard.socketId,
      });
    } catch (error) {
      console.log(error);
    }
  };

  onPrivateMessage = (msg: IReceivedMsg) => {
    chatStore.setMessageList(msg.sender, msg);
  };

  leaveRoom = async () => {
    this.sendSocketMessage('onLeaveRoom', {
      socketId: this.client.socketId,
    });
  };

  sendMessage = (sendData: TSendMessage) => {
    try {
      if (sendData.receiver === 'global') {
        this.sendSocketMessage('sendGlobalMsg', sendData);
        chatStore.setGlobalMsg({
          ...sendData,
          date: new Date(),
        });
      } else {
        this.sendSocketMessage('sendPrivateMsg', sendData);
        chatStore.setMessageList(chatStore.companion.id, {
          ...sendData,
          date: new Date(),
        });
      }
    } catch (error) {
      globalStore.setToasts(true, JSON.stringify(error));
    }
  };

  onAuth = ({ user }: IOnAuth) => {
    this.user = user;
  };

  updateDashboardUsers = (users: { [key: string]: IUser }) => {
    this.dashboardState = users;
  };

  onDubleLogin = ({ id }: any) => {
    if (this.user?.id === id) {
      this.user = null;
      globalStore.dubleLoginLogut();
    }
  };

  getUserImage = (id: string) => {
    if (!this.dashboardState) return '/avatarImg.jpg';
    return (
      this.dashboardState[id]?.readyPlayerMeAvatarImage || '/avatarImg.jpg'
    );
  };

  getUsers = (id: string = '') => {
    try {
      if (!id) {
        const dashboardUsers = this.dashboardState
          ? Object.values(this.dashboardState).filter(
              (user: any) =>
                !user.roomId && user.id != this.myId && user.isAuth,
            )
          : [];
        return dashboardUsers;
      } else {
        const roomUsers = Object.values(this.dashboardState).filter(
          (user: any) =>
            user.roomId === id && user.id != this.myId && user.isAuth,
        );
        return roomUsers;
      }
    } catch (error) {
      console.log(error);
      return [];
    }
  };

  getUserDataById = (id: string) => {
    return this.dashboardState[id] || {};
  };

  connect = async (userId: string) => {
    try {
      this.room = await this.client.joinOrCreate('my_room', userId);
      this.room.onMessage('players_update', (updatedPlayers: any) => {
        delete updatedPlayers[this.room.sessionId];
        runInAction(() => {
          this.gameState = updatedPlayers;
        });
      });
    } catch (error) {
      console.error('Failed to join room:', error);
    }
  };

  sendMovement = (movement: TMovement) => {
    this.room?.send('move', movement);
  };

  clear = () => {};
}

export const socketStore = new SocketStore();
